export default "__VITE_ASSET__BVfZ7Af9__"